import categoriesProps from '../interfaces/CategoryProps';

// Centraliza as rotas do cardápio, que ganharam o nível de subcategoria:
// categorias -> subcategorias -> itens.
// Os nomes vêm do admin e podem conter espaços, acentos ou barras, por isso
// são sempre codificados; o useParams do react-router devolve já decodificado.

const categoriesPath = (menu?: string) => `/cardapio/${menu}/categories`;

const categoryItemsPath = (menu?: string, category?: string) =>
  `${categoriesPath(menu)}/${encodeURIComponent(category || '')}`;

const subcategoriesPath = (menu?: string, category?: string) =>
  `${categoryItemsPath(menu, category)}/subcategories`;

const subcategoryItemsPath = (menu?: string, category?: string, subcategory?: string) =>
  `${subcategoriesPath(menu, category)}/${encodeURIComponent(subcategory || '')}`;

// has_subcategories é o atalho entregue pela API; o array é usado como reforço
// para o caso de a API antiga ainda estar no ar.
const hasSubcategories = (category: categoriesProps) =>
  Boolean(category.has_subcategories) || Boolean(category.subcategories?.length);

export { categoriesPath, categoryItemsPath, subcategoriesPath, subcategoryItemsPath, hasSubcategories };
